/**
 * Трудозатраты. Модуль для работы с API
 * @module laborCosts
 */

import { buildQueryParams, cleanParams } from "@/utils";

/**
 * Получение списка трудозатрат с пагинацией
 * @param {Object} params - параметры запроса
 * @returns {Promise} - данные трудозатрат
 * @throws {Error} - ошибка при получении данных
 */
export const getList = async (params) => {
  const cleanedFilters = cleanParams(params);
  const queryString = buildQueryParams(cleanedFilters);

  try {
    const response = await fetch(`/api/task/worklogs?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 *  Создание фактической трудозатраты
 * @param {object} item - данные фактической трудозатраты
 * @returns {Promise} - созданная трудозатрата
 * @throws {Error} - ошибка при создании данных
 */
export const createItem = async (item) => {
  try {
    const response = await fetch(`/api/task/worklog`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при создании данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.timeEntry;
  } catch (err) {
    throw err;
  }
};

/**
 * Обновление фактической трудозатраты
 * @param {object} item - данные фактической трудозатраты
 * @returns {Promise} - обновленная трудозатрата
 * @throws {Error} - ошибка при обновлении данных
 */
export const updateItem = async (item) => {
  try {
    const response = await fetch(`/api/task/worklog`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при обновлении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.timeEntry;
  } catch (err) {
    throw err;
  }
};

/**
 * Удаление фактической трудозатраты
 * @param {object} item - данные фактической трудозатраты
 * @returns {Promise} - удаленная трудозатрата
 * @throws {Error} - ошибка при удалении данных
 */
export const deleteItem = async (item) => {
  try {
    const response = await fetch(`/api/task/worklog`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при удалении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.timeEntry;
  } catch (err) {
    throw err;
  }
};